import React from "react";
import clsx from "clsx";
import styles from "./ComponentCard.module.css";
import { useStrings } from "../../context/ConfiguratorStringsContext.ts";

export interface PerformanceBarProps {
	percentageDifference: number;
	maxPercentage?: number;
	label?: string;
}

export const PerformanceBar: React.FC<PerformanceBarProps> = ({
	percentageDifference,
	maxPercentage = 100,
	label,
}) => {
	const strings = useStrings();
	const isBetter = percentageDifference > 0;
	const isWorse = percentageDifference < 0;
	const absPercentage = Math.abs(percentageDifference);

	const fillFraction = Math.min(absPercentage / maxPercentage, 1);
	const halfBarPercentage = fillFraction * 50;

	const percentageText =
		absPercentage > 0
			? isBetter
				? strings.product.configBundles.performanceBar.better.replace(
						"{performance}",
						String(Math.round(absPercentage)),
					)
				: strings.product.configBundles.performanceBar.worse.replace(
						"{performance}",
						String(Math.round(absPercentage)),
					)
			: null;

	return (
		<div className={styles.performanceBarContainer}>
			<div className={styles.performanceBarHeader}>
				{percentageText ? (
					<span className={styles.performancePercentLabel}>
						{percentageText}
					</span>
				) : (
					<span className={styles.performanceBarLabel}>{label}</span>
				)}
			</div>
			<div className={styles.performanceBarTrack} aria-hidden="true">
				<div
					className={clsx(
						styles.performanceBarFill,
						styles.performanceBarWorse,
					)}
					style={{ width: isWorse ? `${halfBarPercentage}%` : "0%" }}
				/>
				<div className={styles.performanceBarCenter} />
				<div
					className={clsx(
						styles.performanceBarFill,
						styles.performanceBarBetter,
					)}
					style={{ width: isBetter ? `${halfBarPercentage}%` : "0%" }}
				/>
			</div>
		</div>
	);
};